import {httpGet,httpPut,httpDelete,httpPost} from '../../../util/request.js';
import appConfig from '../../../config';

export default class OrgApi{

    // static QUERY_PRIVILEDGED_ORG_API_URL = appConfig.gatewayUrl+appConfig.atuhServicePath+"/auth/shopPriviledge";
	
	// static queryShopPriviledge(params){
	// 	return httpGet(OrgApi.QUERY_PRIVILEDGED_ORG_API_URL,params);
    // }
    
    static QUERY_ORG_API_URL = appConfig.gatewayUrl+appConfig.smpServicePath+"/org/orgs";
    static GET_ORG_API_URL = appConfig.gatewayUrl+appConfig.smpServicePath+"/org/org";
    static PERSIST_ORG_API_URL = appConfig.gatewayUrl+appConfig.smpServicePath+"/org/org";
	
	static queryOrgs(params){
		return httpGet(OrgApi.QUERY_ORG_API_URL,params);
    }

    static getOrg(params){
        return httpGet(OrgApi.GET_ORG_API_URL,params);
    }

    static persistOrg(params){
        return httpPost(OrgApi.PERSIST_ORG_API_URL,params);
    }
	
}